import styled from 'styled-components';
import media from '../../../themes/media';

const Layout = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding-top: ${(props) =>
    `calc(${props.theme.sizing.menuHeight} + ${
      props.additionalHeight || 0
    }px)`};
  width: 100vw;
  overflow: hidden;
  max-height: 100vh;

  ${media.greaterThan('desktop')`
    flex-direction: row;
    padding-top: 0;
  `}

  ${media.lessThan('tablet')`
    padding-top: 58px;
  `}
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  scroll-behavior: smooth;
  overflow-y: scroll;

  > * {
    flex-grow: 1;
  }
`;

export { Layout, Content };
